import { render } from "./static-button-conf.vue?vue&type=template&id=6cc13eee&scoped=true"
import script from "./static-button-conf.vue?vue&type=script&lang=js"
export * from "./static-button-conf.vue?vue&type=script&lang=js"

import "./static-button-conf.vue?vue&type=style&index=0&id=6cc13eee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc13eee"]])

export default __exports__